import React from 'react';
import { at } from 'lodash';
import { useField } from 'formik';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    '& .MuiFormControlLabel-root': {
      alignItems: 'flex-start',
      '& > span': {
        '&:first-child': {
          height: 'fit-content',
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    }
  }
}));

export default function CheckboxField(props) {
  const classes = useStyles();
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const [touched, error] = at(meta, 'touched', 'error');
  const { setValue } = helper;
  const isError = touched && error && true;

  function _renderHelperText() {
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  function _onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <FormControl className={classes.formControl} {...rest} error={isError}>
      <FormControlLabel
        value={field.value}
        checked={!!field.value}
        control={<Checkbox {...field} onChange={_onChange} />}
        label={label}
      />
      {_renderHelperText()}
    </FormControl>
  );
}
